import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { Form, Modal, Dropdown } from 'react-bootstrap'
import { FaTag, FaFileAlt, FaSmile, FaImage, FaHashtag, FaExclamationTriangle } from 'react-icons/fa'
import { Title } from '../../../../../Templates/Title'
import { CreatePromotionRequest, Promotion } from '../../../../API/Promotions/models'
import { createPromotion, updatePromotion } from '../../../../API/Promotions/promotions'
import toast from 'react-hot-toast'
import { openImage } from '../../../../../Utils/images'

interface CreatePromotionModalProps {
  show: boolean
  onHide: () => void
  fetchPromotions: () => void
  promotion: Promotion | null
}

export const CreatePromotionModal = ({ show, onHide, fetchPromotions, promotion }: CreatePromotionModalProps) => {
  const [showEmojis, setShowEmojis] = useState(false);
  const [form, setForm] = useState<CreatePromotionRequest>({
    name: '',
    description: '',
    image: '',
    disclaimer: '',
    code: '',
  });

  const emojis = ['🎮', '💰', '🎯', '🎲', '🎁', '💎', '⭐', '🔥', '✨', '💫', '🌟', '💪', '🎉', '🏆', '💯', '😊', '😄', '😁', '😆', '😍', '🤩', '😎', '🙂', '😉', '😇'];
  const insertEmoji = (emoji: string) => {
    setForm({ ...form, description: form.description + emoji });
  };


  const handleSubmit = () => {
    if (promotion?.id) {
      handleUpdatePromotion();
    } else {
      handleCreatePromotion();
    }
  }

  const handleCreatePromotion = () => {
    const promotion: CreatePromotionRequest = {
      name: form.name,
      description: form.description,
      image: form.image,
      disclaimer: form.disclaimer,
      code: form.code,
    }; try {
      createPromotion(promotion).then((result) => {
        toast.success('Promoción creada');
        fetchPromotions();
        onHide();
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdatePromotion = () => {
    if (!promotion) return;

    const promotionToUpdate: Promotion = {
      id: promotion.id,
      name: form.name,
      description: form.description,
      image: form.image,
      disclaimer: form.disclaimer,
      code: form.code,
    }

    try {
      updatePromotion(promotionToUpdate).then((result) => {
        toast.success('Promoción actualizada');
        fetchPromotions();
        onHide();
      });
    } catch (error) {
      console.log(error);
    }
  }

  const handleImageUploadBase64 = (file: File | undefined) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result as string;
      setForm({ ...form, image: base64 });
    };
    reader.readAsDataURL(file);
  }

  useEffect(() => {
    if (promotion) {
      setForm({
        name: promotion.name,
        description: promotion.description,
        image: promotion.image,
        disclaimer: promotion.disclaimer,
        code: promotion.code,
      });
    }
  }, [promotion]);
  return (
    <Modal show={show} onHide={onHide} size='lg' backdrop="static" keyboard={false} centered>
      <div className="border border-secondary rounded-3 px-4">
        <Modal.Header closeButton>
          <Modal.Title>Crear promoción</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-4">
            <Title
              title='Nombre de la promoción'
              subtitle='Escribe un nombre corto y descriptivo'
              icon={<FaTag size={22} />}
            />
            <Form.Control
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              type="text"
              placeholder="Ejemplo: 2x1 en recargas"
              className="bg-darker text-light border-secondary"
            />
          </Form.Group>


          <Form.Group className="mb-4">
            <Title
              title='Código'
              subtitle='Escribe un código para la promoción'
              icon={<FaHashtag size={22} />}
            />
            <Form.Control
              value={form.code}
              onChange={(e) => setForm({ ...form, code: e.target.value })}
              type="text"
              placeholder="Ejemplo: PROMO34"
              className="bg-darker text-light border-secondary"
            />
          </Form.Group>


          <Form.Group className="mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <Title
                title='Descripción'
                subtitle='Describe los detalles y condiciones de la promoción'
                icon={<FaFileAlt size={22} />}
              />
              <Dropdown show={showEmojis} onToggle={(isOpen) => setShowEmojis(isOpen)}>
                <Dropdown.Toggle
                  variant="outline-secondary"
                  className="p-2"
                  style={{ minWidth: '40px' }}
                >
                  <FaSmile size={20} />
                </Dropdown.Toggle>
                <Dropdown.Menu className="bg-dark p-2" style={{ maxWidth: '200px' }}>
                  <div className="d-flex flex-wrap gap-2">
                    {emojis.map((emoji, index) => (
                      <span
                        key={index}
                        role="button"
                        onClick={() => insertEmoji(emoji)}
                        style={{ fontSize: '20px' }}
                      >
                        {emoji}
                      </span>
                    ))}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <Form.Control
              as="textarea"
              style={{ minHeight: '150px' }}
              placeholder="Ejemplo: Recarga 1000 fichas y recibe 2000 fichas gratis"
              className="bg-darker text-light border-secondary"
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
            />
          </Form.Group>


          <Form.Group className="mb-4">
            <Title
              title='Disclaimer'
              subtitle='Escribe un disclaimer para la promoción'
              icon={<FaExclamationTriangle size={22} />}
            />
            <Form.Control
              value={form.disclaimer}
              onChange={(e) => setForm({ ...form, disclaimer: e.target.value })}
              type="text"
              placeholder="Ejemplo: No se puede combinar con otras promociones"
              className="bg-darker text-light border-secondary"
            />
          </Form.Group>

          {/* image */}
          <Form.Group className="mb-4">
            <Title title="Imagen" subtitle="Agrega una imagen o flyer para la promoción" icon={<FaImage size={22} />} />
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleImageUploadBase64(e.target.files?.[0])}
            />
            {form?.image && (
              <div onClick={() => openImage(form.image ?? '')} role='button'>
                <img src={form.image} alt="Promoción" className="mt-2" width={100} />
              </div>
            )}
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>{promotion?.id ? 'Actualizar' : 'Crear'} promoción</Button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}
